import { useEffect, useState } from "react";
import { scrollToId } from "@/lib/scroll";

const navLinks = [
  { id: "exclusive", label: "独家抢先" },
  { id: "flash", label: "速递快讯" },
  { id: "hot", label: "热点榜单" },
  { id: "category", label: "吃瓜分类" },
  { id: "faq", label: "吃瓜指南" },
  { id: "about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={
        "sticky top-0 z-40 transition-colors duration-300 " +
        (scrolled || open
          ? "border-b border-stone-200 bg-paper/95 backdrop-blur"
          : "border-b border-transparent bg-paper")
      }
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            go("hero");
          }}
          className="group flex items-center gap-2.5"
          aria-label="吃瓜前线首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500 font-heading text-lg font-black text-white group-hover:bg-brand-600">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-[19px] font-black tracking-wide text-[#241b13]">
              吃瓜前线
            </span>
            <span className="mt-0.5 text-[11px] tracking-[0.2em] text-brand-600">
              速递 · 快讯 · 独家
            </span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              className="rounded-md px-3.5 py-2 text-[14px] font-medium text-stone-700 transition-colors hover:bg-brand-50 hover:text-brand-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2.5 lg:flex">
          <span className="hidden items-center gap-1 rounded-full border border-stone-200 bg-white px-3 py-1.5 text-[12px] text-stone-500 xl:flex">
            <i className="ri-search-line text-stone-400" />
            搜索吃瓜前线热点
          </span>
          <button
            onClick={() => go("newsletter")}
            className="whitespace-nowrap rounded-lg bg-brand-500 px-4 py-2 text-[14px] font-semibold text-white transition-colors hover:bg-brand-600"
          >
            投稿吃瓜
          </button>
        </div>

        {/* 移动端按钮 */}
        <button
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-stone-200 bg-white lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "收起菜单" : "展开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl text-stone-700" : "ri-menu-3-line text-xl text-stone-700"} />
        </button>
      </div>

      {/* 移动端菜单 */}
      <div
        className={
          "overflow-hidden border-stone-200 bg-paper transition-all duration-300 lg:hidden " +
          (open ? "max-h-[420px] border-b" : "max-h-0")
        }
      >
        <nav className="mx-auto flex max-w-[1400px] flex-col gap-1 px-4 py-3" aria-label="移动导航">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              className="rounded-md px-3 py-2.5 text-[15px] font-medium text-stone-700 hover:bg-brand-50 hover:text-brand-700"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => go("newsletter")}
            className="mt-2 whitespace-nowrap rounded-lg bg-brand-500 px-4 py-2.5 text-center text-[15px] font-semibold text-white"
          >
            投稿吃瓜 · 线索征集
          </button>
        </nav>
      </div>
    </header>
  );
}